<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title text-center">互動遊戲</h2>
            <ul>
                <li>
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/game/arMenu')"
                    >
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_img1.png"
                                    alt="川閱古今"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">川閱古今</div>
                                <div class="text">
                                    遊戲說明：應用AR擴增實境，將現在地景與昔日景觀結合在一起，重現舊照片及整治前後，呈現城市記憶與地景融合，讓民眾對所在城市有更深入了解。
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="./green-river" class="d-block" target="_blank">
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_img2.png"
                                    alt="治水小尖兵"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">治水小尖兵</div>
                                <div class="text">
                                    遊戲說明：全臺第一座採低衝擊開發的景觀河岸就在臺中市柳川。採用低衝擊開發工法包含透水舖面、入滲溝、雨水花園、入滲乾井、植生溝及地下水撲滿等，遊戲中透過將這些工法拖曳到正確施工位置，認識治水小知識。
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <!--<li>
                    <a
                        href="https://app.pictarize.com/p?projectId=62271b671781190011e873a8&buildId=62a6f696819ae900117bdf48"
                        class="d-block"
                        target="_blank"
                    >
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_img3.png"
                                    alt="柳川停看聽"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">柳川停看聽</div>
                                <div class="text">
                                    遊戲說明：透過圖像辨識，即會出現柳川吉祥物-柳妹的3D模型。
                                </div>
                            </div>
                        </div>
                    </a>
                </li>-->
                <li>
                    <a
                        href="https://playcanv.as/p/qenKUTTK/"
                        class="d-block"
                        target="_blank"
                    >
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_img3.png"
                                    alt="柳川停看聽(非圖像辨識版)"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">
                                    柳川停看聽(非圖像辨識版)
                                </div>
                                <div class="text">
                                    遊戲說明：打開連結即會跳出柳川吉祥物-柳妹的3D模型。
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="./questions-and-answers"
                        target="_blank"
                        class="d-block"
                    >
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_img4.png"
                                    alt="柳川知識王"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">柳川知識王</div>
                                <div class="text">
                                    遊戲說明：透過趣味學習單，測試民眾對於柳川的認識及瞭解，除了增添小知識外，也饒富樂趣。本遊戲共規劃10題單選題如下，民眾答題完成後將獲得成績單和顯示分數。
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.facebook.com/fbcameraeffects/tryit/443243834338451/"
                        target="_blank"
                        class="d-block"
                    >
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_img5.jpg"
                                    alt="綠柳川的時光隧道之旅"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">綠柳川的時光隧道之旅</div>
                                <div class="text">
                                    遊戲說明：穿越時光回到綠柳川的過去？以為遺失的記憶，用拍照走進時光隧道淺嚐體會過去的時光
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="./game2024/"
                        target="_blank"
                        class="d-block"
                    >
                        <div class="game-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    src="@/assets/game_item_礫間水質大作戰.jpg"
                                    alt="礫間水質大作戰"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title">礫間水質大作戰</div>
                                <div class="text">
                                    遊戲說明：模擬礫間水質淨化工法，利用礫石粗糙的孔隙與微生物將污水淨化。
                                </div>
                                <div class="text">
                                    接受這場河川淨化任務，讓水質重現清澈明亮的模樣吧！
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
        };
    },
    methods: {
        goView(link) {
            this.$router.push(link).catch(() => {});
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
